import React from 'react'

const systemContext = React.createContext({});

export { systemContext }

// Check './system-provider' for system options handler
